import {
  getEnvironment,
  isDevEnv,
} from 'shared/utils/environment/determineEnvironment';
import { LogData, LogLevel, SharedLogsParams } from 'shared/types/logger';
import { ENVIRONMENTS } from 'shared/utils/environment/types';
import {
  clearSensitiveDataFromDetailsObject,
  getDeviceInfo,
} from './helpers';
import { normalizeLogDetails } from 'shared/utils/errorHandling';

const environment = getEnvironment();

function extractLogDataFromParams(params: SharedLogsParams): LogData {
  const normalizedDetails = normalizeLogDetails(params.full_error_object);
  const clearedDetails = normalizedDetails
    ? clearSensitiveDataFromDetailsObject(normalizedDetails)
    : undefined;
  const detailKey =
    params.level === LogLevel.ERROR ? 'full_error_object' : 'details';
  const additionalInfo = params.additionalInfo || {};

  const detailData =
    clearedDetails !== undefined ? { [detailKey]: clearedDetails } : {};

  return {
    logId: params.logId,
    msg: params.msg,
    level: params.level,
    user_id: params.user_id,
    user_email: params.user_email,
    grouping: params.grouping,
    ...getDeviceInfo(),
    ...additionalInfo,
    ...detailData,
  };
}

export const sharedLog = (params: SharedLogsParams): void => {
  const logData = extractLogDataFromParams(params);
  if (!isDevEnv()) {
    params.loggers.forEach((logger) => {
      try {
        const result = logger.log(logData);
        if (
          result &&
          typeof (result as Promise<unknown>).catch === 'function'
        ) {
          (result as Promise<unknown>).catch(() => {});
        }
      } catch (_error) {}
    });
  }
  if (environment !== ENVIRONMENTS.PRODUCTION) {
    const log =
      // eslint-disable-next-line no-console
      params.level === LogLevel.ERROR ? console.error : console.log;
    log(
      'Log level:',
      params.level,
      'Message:',
      params.msg,
      'Object:',
      params.full_error_object
    );
    log(logData);
  }
};
